import lazyLoadView from '@router/lazyload-view'

export default [
  // 404
  {
    path: '/404',
    name: '404',
    component: require('@views/_404-db').default,
    meta: {
      showBreadcrumb: false,
    },
    props: true,
  },
  // 首頁
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/Home/Index.vue')),
  },
  // 方案價格
  {
    path: '/price',
    name: 'price',
    component: () => lazyLoadView(import('@views/Price/Index.vue')),
  },
  // 初階方案
  {
    path: '/basic-plan',
    name: 'basicPlan',
    component: () => lazyLoadView(import('@views/BasicPlan/Index.vue')),
  },
  // 進階方案
  {
    path: '/advanced-plan',
    name: 'advancedPlan',
    component: () => lazyLoadView(import('@views/AdvancedPlan/Index.vue')),
  },
  // 專人聯繫
  {
    path: '/contact',
    name: 'contact',
    component: () => lazyLoadView(import('@views/Contact/Index.vue')),
  },
  // line notify 綁定
  {
    path: '/line-notify',
    name: 'lineNotify',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const {code = undefined, state = undefined} = routeTo.query
        if (code === undefined && state === undefined) {
          next({
            name: 'home',
            replace: true,
          })
        } else {
          const bindUrl = state
          const success = !!code
          const url = `${bindUrl}?code=${code}&success=${success}`;
          window.location.href = url
        }
      }
    }
  },
  {
    path: '*',
    redirect: '404',
  },
]
